// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ScoringTraitWeight, ScoringTraitWeightSchema } from 'api/gen/ScoringTraitWeight';

const requiredPart = t.interface({
  firstChildbirthDifficultyWeight: ScoringTraitWeightSchema,
  heifersFertilityWeight: ScoringTraitWeightSchema,
  longevityWeight: ScoringTraitWeightSchema,
  milkabilityWeight: ScoringTraitWeightSchema,
});

export const FunctionalTraitsWeightsSchema = excess(requiredPart);

export interface FunctionalTraitsWeights extends t.TypeOf<typeof FunctionalTraitsWeightsSchema> {}
